// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nvwc-dialog[data-v-60a05167] {\n  --mdc-dialog-max-width: 424px;\n}\n", ""]);
// Exports
module.exports = exports;
